import React, { useEffect, useRef, useState } from 'react';
import styles from './SGSCopyButton.module.scss';
import classnames from 'classnames';

type Props = {
    value: string;
    className?: string;
};

const SGSCopyButton: React.FC<Props> = ({ value, className }) => {
    const mountedRef = useRef(false);
    const [copied, setCopied] = useState(false);

    const handleClick = () => {
        const textField = document.createElement('textarea');
        textField.value = value;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        setCopied(true);
        setTimeout(() => {
            if (mountedRef.current) {
                setCopied(false);
            }
        }, 1000);
    };

    useEffect(() => {
        mountedRef.current = true;

        return () => {
            mountedRef.current = false;
        };
    }, []);

    return (
        <div className={classnames('d-flex align-items-center', className)}>
            <span className={styles.copy} onClick={handleClick}>
                <i className="fas fa-copy"></i>
            </span>
            <span className={classnames('ml-1', styles.check, copied && styles.copied)}>
                <i className="fas fa-check"></i>
            </span>
        </div>
    );
};

export default SGSCopyButton;
